exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1xQN_BsuwFLkCZlKxTYui9{position:absolute;top:0;bottom:0;z-index:-1}html[dir] ._1xQN_BsuwFLkCZlKxTYui9{background-color:\"[theme:neutralLighterAlt, default:#f8f8f8]\"}html[dir=ltr] ._1xQN_BsuwFLkCZlKxTYui9,html[dir=rtl] ._1xQN_BsuwFLkCZlKxTYui9{left:0;right:0}", ""]);

// exports
exports.locals = {
	"pastHighlight": "_1xQN_BsuwFLkCZlKxTYui9"
};